__turbopack_context__.v({
  "search": "search-module-scss-module__3shsla__search",
  "searchIcon": "search-module-scss-module__3shsla__searchIcon",
});
